module.exports = __webpack_public_path__ + "static/media/paper-money-two.060e23ab.svg";